'use es6';

import { DefaultQuery, QueryParams } from '../Constants';
import OrderByField from '../enums/OrderByField';
import * as SortDirection from '../enums/SortDirection';
import { parseFileTypeFromLocation, parseFolderIdFromLocation, parseQueryObject } from './location';
function parseOrderBy(queryObj) {
  const {
    orderBy
  } = queryObj;
  return Object.values(OrderByField).includes(orderBy) ? orderBy : DefaultQuery.get(QueryParams.orderBy);
}
function parseSortDirection(queryObj) {
  const {
    sortDirection
  } = queryObj;
  return Object.values(SortDirection).includes(sortDirection) ? sortDirection : DefaultQuery.get(QueryParams.sortDirection);
}
function parseArchived(queryObj) {
  return queryObj.archived === 'true';
}
function parsePage(queryObj) {
  return parseInt(queryObj.page, 10) || 1;
}
export default function getQueryFromLocation(location) {
  if (!location) {
    return DefaultQuery.toJS();
  }
  const queryObj = parseQueryObject(location);
  return Object.assign({}, DefaultQuery.merge(queryObj).toJS(), {
    page: parsePage(queryObj),
    archived: parseArchived(queryObj),
    orderBy: parseOrderBy(queryObj),
    sortDirection: parseSortDirection(queryObj),
    fileType: parseFileTypeFromLocation(location),
    folderId: parseFolderIdFromLocation(location)
  });
}